module.exports = __webpack_public_path__ + "static/media/rating.bb82db88.png";